export default "__VITE_ASSET__DSP8bwXI__"